import {ObjectDTO} from "../object-dto";

export class TypeTachePmsDto extends ObjectDTO {
  libelle: string;
}
